module.exports = __webpack_public_path__ + "img/logo.739d68cf.png";